// export const data = [
//   { id: 1, title: "Therapist" },
//   { id: 2, title: "Palm reader" },
//   { id: 3, title: "Astrologer" },
//   { id: 4, title: "Tarot reader" },
//   { id: 5, title: "Psychologist" },
//   { id: 6, title: "Psychiatrist" },
//   { id: 7, title: "Relationship Counsellor" },
//   { id: 8, title: "Numerologist" },
//   { id: 9, title: "Sex Specialist" },
// ];

export const consultantCategory = [
  {
    id: 1,
    title: "Counselor",
    value: "relationship-counselor",
  },
  {
    id: 2,
    title: "Therapist",
    value: "therapist",
  },
  {
    id: 3,
    title: "Palm reader",
    value: "palm-reader",
  },
  {
    id: 4,
    title: "Astrologer",
    value: "astrologer",
  },
  {
    id: 5,
    title: "Tarot reader",
    value: "tarot-reader",
  },
  {
    id: 6,
    title: "Chat Buddy",
    value: "chatbuddy",
  },
  {
    id: 7,
    title: "Psychiatrist",
    value: "psychiatrist",
  },

  {
    id: 8,
    title: "Numerologist",
    value: "numerologist",
  },
  {
    id: 9,
    title: "Sex Specialist",
    value: "sex-specialist",
  },
];
